import React, { useEffect, useState, useCallback, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import CommaConvert from "../../../../utils/CommaConvert";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../utils/decimalAmountUtils";
import { getAllAutoSaveWorkentries, replaceAllWorkEntries } from "../../../../store/slices/autosaveSlice";
import { fetchDescriptionTasks } from "../../../../store/slices/DescriptionTask";
import { replaceAllDescriptionTasks } from "../../../../store/slices/descriptionTaskSlice";
import { replaceAllHardwareDescriptions } from "../../../../store/slices/hardwareDescriptionSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import { updateTaskStatus } from "../../../../store/slices/projectTaskStatusSlice";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import SubmitLoader from "../../../../components/common/loader/SubmitLoader";
import { submitWorkEntries } from "../../../../store/slices/submitTaskSlice";
import { deleteTask, fetchWorkEntries } from "../../../../store/slices/workentriesSlice";
import {
  collapseTrainingBundlesToSingleRowPerAssignee,
  consolidateTrainingExpenseRowsForDisplay,
  resolveInstallationOtherExpenseRowsForPersistence,
  filterInstallationOngoingOtherExpenseDisplayRows,
  formatExpenseNotesDisplayFromTasksRow,
  getLiveTrainingRollupForOpsAssigneeProject,
  getTrainingExpenseBundlesForManagerResource,
  isTrainingExpenseDisplayRow,
  mergeInstallationOtherExpenseRowsWithDefaults,
  mergeTrainingExpenseRowsInto,
  normalizeAssignmentTypeServiceKey,
  normalizeDescriptionTaskWireEntry,
  normalizeTaskIdForScope,
  taskMatchesOpsManagerResourceOtherExpenses,
} from "../../../../utils/trainingOtherExpenseSync";

const ManagerTaskInputTable = ({
  setSelectedActions,
  opemail,
  rowsManager,
  setRowsManager,
  handleAddRowManagerEdit,
  selectedemail,
  selectedServiceType,
  managerOPID,
  managerOPProject,
  row,
  Action,
  setAction,
  hardwareAction,
  setHardwareAction,
  employees,
  tasks,
  items,
  hardwareData,
  handlerefresh,
  taskTableRowId,
  isProjectRequestedBucket,
}) => {
  const sanitizeDecimalInput = (inputValue) => {
    const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
    const [integerPart, ...decimalParts] = cleaned.split(".");
    if (decimalParts.length === 0) return integerPart;
    return `${integerPart}.${decimalParts.join("")}`;
  };
  const getHoursValue = (entry = {}) =>
    entry.hoursassigned ?? entry.hours ?? "";
  const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
  const getTypeServiceTabScopeKey = (typeService) => {
    const list = Array.isArray(typeService)
      ? typeService
      : typeService
        ? [typeService]
        : [];
    return list.map((s) => String(s || "").toLowerCase()).sort().join("|");
  };
  const [filteredEntries, setFilteredEntries] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();

  const dispatch = useDispatch();
  const { autosaveentries } = useSelector((state) => state.autosave);
  const { entries } = useSelector((state) => state.workentries);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);
  const [managerDebounceTimer, setManagerDebounceTimer] = useState(null);
  const [isLoadingtask, setisLoadingtask] = useState(false);
  const [typingTimeout, setTypingTimeout] = React.useState(null);
  const [tripduration, setTripDuration] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [Assignperson, setAssignperson] = useState("");
  const [currentAssignperson, setcurrentAssignperson] = useState("");
  const [hardware, setHardware] = useState([
    {
      assemblepartdescription: "",
      partno: "",
      quantity: "",
      unitprice: "",
      totalprice: "",
    },
  ]);
  const [, setInitialEdit] = useState(false);
  const skipServerSyncRef = useRef(false);

  useEffect(() => {
    skipServerSyncRef.current = false;
    setInitialEdit(false);
  }, [row?._id, selectedemail, opemail]);

  const markUserEditing = () => {
    skipServerSyncRef.current = true;
    setInitialEdit(true);
  };

  useEffect(() => {
    if (row && row.Assignedperson) {
      const assignedPerson = row.Assignedperson.find(
        (person) => person.email === opemail
      );
      setAssignperson(assignedPerson);
    }
  }, [row, opemail]);
  const defaultTabScopeKey = `${row?._id ?? ""}|${selectedemail ?? ""}|${getTypeServiceTabScopeKey(selectedServiceType)}`;
  const prevDefaultTabScopeRef = useRef(null);
  useEffect(() => {
    if (prevDefaultTabScopeRef.current === defaultTabScopeKey) return;
    prevDefaultTabScopeRef.current = defaultTabScopeKey;

    const hasHardware = Array.isArray(selectedServiceType)
      ? selectedServiceType.some((service) => service.includes("Hardware"))
      : selectedServiceType?.includes("Hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [defaultTabScopeKey, selectedServiceType, setAction, setHardwareAction]);

  useEffect(() => {
    if (hardware.length === 0) {
      setHardware([
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
        },
      ]);
    }
  }, [hardware, setHardware]);

  const [filteredPersonDescription, setFilteredPersonDescription] = useState(
    []
  );

  const [installation, setInstallation] = useState([
    { description: `Airfare (${currency})`, value: "", notes: "" },
    { description: `Car Rental (${currency})`, value: "", notes: "" },
    { description: `Car fuel (${currency})`, value: "", notes: "" },
    { description: `Lodging (${currency})`, value: "", notes: "" },
    {
      description: `Miscellaneous Install Items to buy (${currency}) `,
      value: "",
      notes: "",
    },
  ]);

  const tripRowsAssigneeScopeKey = `${selectedemail ?? ""}|${row?._id ?? ""}`;
  const effortRowsScopeKey = `${opemail ?? ""}|${managerOPProject?._id ?? ""}|${row?._id ?? ""}`;
  const prevTripScopeRef = useRef(tripRowsAssigneeScopeKey);
  const prevEffortScopeRef = useRef(effortRowsScopeKey);
  const [tripRowsUserEditing, setTripRowsUserEditing] = useState(false);
  const [effortRowsUserEditing, setEffortRowsUserEditing] = useState(false);
  const [installationUserEditing, setInstallationUserEditing] = useState(false);
  const skipInstallationServerSyncRef = useRef(false);

  useEffect(() => {
    if (prevTripScopeRef.current !== tripRowsAssigneeScopeKey) {
      prevTripScopeRef.current = tripRowsAssigneeScopeKey;
      setTripRowsUserEditing(false);
      setInstallationUserEditing(false);
      setTripDuration("");
    }
    if (prevEffortScopeRef.current !== effortRowsScopeKey) {
      prevEffortScopeRef.current = effortRowsScopeKey;
      setEffortRowsUserEditing(false);
    }
  }, [tripRowsAssigneeScopeKey, effortRowsScopeKey]);

  const moveMiscellaneousInstallRowToEnd = useCallback((rows = []) => {
    const miscIndex = rows.findIndex((r) =>
      String(r?.description || "").toLowerCase().includes("miscellaneous install items")
    );
    if (miscIndex === -1) return rows;
    const miscRow = rows[miscIndex];
    return [...rows.slice(0, miscIndex), ...rows.slice(miscIndex + 1), miscRow];
  }, []);

  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);
  const rowIsInstallation = normalizeAssignmentTypeServiceKey(row?.TypeService) === "installation";

  useEffect(() => {
    if (!rowIsInstallation) return;
    if (installationUserEditing) return;
    if (skipInstallationServerSyncRef.current) return;
    const userEmail = selectedemail;
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const employeeId = currentEmployee?._id;
    setcurrentAssignperson(employeeId);
    const matchedTasks = tasks?.filter(
      (task) =>
        taskMatchesOpsManagerResourceOtherExpenses(task, row, managerOPProject) &&
        (!employeeId ||
          normalizeTaskIdForScope(task?.taskownerid) === normalizeTaskIdForScope(employeeId))
    );

    if (matchedTasks?.length) {
      const tasksForLoad =
        Assignperson?.taskStatus === "submit"
          ? filterInstallationOngoingOtherExpenseDisplayRows(matchedTasks, row)
          : matchedTasks;
      const merged = mergeInstallationOtherExpenseRowsWithDefaults(tasksForLoad, currency);
      setInstallation(moveMiscellaneousInstallRowToEnd(merged));
      const tripDur =
        merged.find((t) => t.tripduration != null && String(t.tripduration).trim() !== "")?.tripduration ??
        matchedTasks.find((t) => t.tripduration != null)?.tripduration;
      setTripDuration(tripDur != null && tripDur !== "" ? String(tripDur) : "");
      setFilteredEntries(matchedTasks);
    } else {
      setInstallation([
        { description: `Airfare (${currency})`, value: "", notes: "" },
        { description: `Car Rental (${currency})`, value: "", notes: "" },
        { description: `Car fuel (${currency})`, value: "", notes: "" },
        { description: `Lodging (${currency})`, value: "", notes: "" },
        {
          description: `Miscellaneous Install Items to buy (${currency})`,
          value: "",
          notes: "",
        },
      ]);
      setTripDuration("");
    }
  }, [tasks, row, managerOPProject, employees, selectedemail, currency, moveMiscellaneousInstallRowToEnd, rowIsInstallation, installationUserEditing, Assignperson?.taskStatus]);
  const { inventory } = useSelector((state) => state.assemblyInventory);
  const SidebarGroup = useSelector((state) => state.sidebar.SidebarGroup);

  useEffect(() => {
    // Filter by SidebarGroup (selected group from Settings like "Sensr")
    // If SidebarGroup is not set, fall back to row?.AssignedGroup
    const selectedGroup = SidebarGroup || row?.AssignedGroup;
    
    // Use inventory from Redux if available, otherwise fall back to hardwareData prop
    const dataSource = inventory && inventory.length > 0 ? inventory : hardwareData;
    
    const matchedtaskEntries = dataSource.filter(
      (entry) => entry.group === selectedGroup
    );
    
    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));

    setfetchedHardwareData(newhardwareRows);
  }, [hardwareData, employees, row, inventory, SidebarGroup]);
  useEffect(() => {
    const currentEmployee = employees?.find(
      (emp) => emp.EmpEmail === selectedemail
    );
    if (currentEmployee && items && row) {
      const filteredHardware = items?.filter(
        (item) =>
          normalizeTaskIdForScope(item?.taskownerid) ===
            normalizeTaskIdForScope(currentEmployee._id) &&
          taskMatchesOpsManagerResourceOtherExpenses(
            { projectid: item.projectid, taskownerid: item.taskownerid, typeservice: item.typeservice },
            row,
            managerOPProject
          )
      );
      setFilteredEntries(filteredHardware);
      if (filteredHardware?.length > 0) {
        setHardware(
          filteredHardware?.length > 0
            ? filteredHardware
            : [
              {
                assemblepartdescription: "",
                partno: "",
                quantity: "",
                unitprice: "",
                totalprice: "",
                taskownerid: currentEmployee._id,
              },
            ]
        );
      }
    }
  }, [items, selectedemail, row, employees, managerOPProject]);

  useEffect(() => {
    const currentEmployee = employees.find(
      (emp) => emp.EmpEmail === selectedemail
    );

    if (currentEmployee?._id) {
      setcurrentAssignperson(currentEmployee._id);
    }

    if (currentEmployee) {
      const matchedTasks = tasks.filter(
        (task) =>
          normalizeTaskIdForScope(task?.taskownerid) ===
            normalizeTaskIdForScope(currentEmployee._id) &&
          taskMatchesOpsManagerResourceOtherExpenses(task, row, managerOPProject)
      );
      setFilteredPersonDescription(matchedTasks);
      setFilteredEntries(matchedTasks);
    } else {
      setFilteredPersonDescription([]);
    }
  }, [tasks, managerOPID, employees, managerOPProject, selectedemail, row]);

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
  }, [dispatch]);

  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);

  const appendManualOtherExpenseRow = (prev) => {
    const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
    const trains = (prev || []).filter((r) => isTrainingExpenseDisplayRow(r));
    if (manuals.length >= 15) return prev;
    return [...manuals, { description: "", value: "", notes: "" }, ...trains];
  };

  const buildOrderedOtherExpenseDisplayRows = (rows) => {
    const raw = ([]).concat(rows || []);
    const annotated = raw.map((r, stateIndex) => ({ r, stateIndex }));
    const manualRows = annotated.filter(({ r }) => !isTrainingExpenseDisplayRow(r));
    const trainingRows = annotated.filter(({ r }) => isTrainingExpenseDisplayRow(r));
    return [...manualRows, ...trainingRows].map(({ r, stateIndex }) => {
      const train = Boolean(isTrainingExpenseDisplayRow(r));
      return {
        ...r,
        stateIndex,
        sourceType: r.sourceType,
        sourceTrainingId: r.sourceTrainingId,
        isTrainingExpense: train,
        readOnly: Boolean(train || r.readOnly),
        _readonlyExpense: Boolean(train || r.readOnly),
        _syntheticTrainingRow: Boolean(r._syntheticTrainingRow || r._prmSyntheticTrainingExpense),
      };
    });
  };

  const installationForTableDisplay =
    rowIsInstallation && Assignperson?.taskStatus === "submit"
      ? filterInstallationOngoingOtherExpenseDisplayRows(installation, row)
      : installation;
  const installationRowsForTable = buildOrderedOtherExpenseDisplayRows(installationForTableDisplay);
  const tripRowsForTable = buildOrderedOtherExpenseDisplayRows(triprows);

  const installationOtherGrandTotal = installationRowsForTable.reduce(
    (sum, item) => sum + parseAmountNumber(item.value),
    0
  );
  const tripOtherGrandTotal = tripRowsForTable.reduce(
    (sum, item) => sum + parseAmountNumber(item.value),
    0
  );

  const trainingExpenseRowStyle = { backgroundColor: "#f1f3f5", opacity: 0.85 };
  const readOnlyExpenseCellCls =
    "bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed rounded-md px-1";
  const trainingExpenseInputCls =
    "outline-none border-none text-center w-full h-full bg-transparent text-[#6b7280] cursor-not-allowed rounded-md px-1";

  const expenseInputDisabled = (expRow) =>
    Boolean(expRow.isTrainingExpense || expRow._readonlyExpense || expRow.readOnly);

  const expenseInputCellCls = (expRow) =>
    expenseInputDisabled(expRow)
      ? expRow.isTrainingExpense
        ? trainingExpenseInputCls
        : readOnlyExpenseCellCls
      : "";


  const handleRemoveRowManagerEdit = (index) => {
    setEffortRowsUserEditing(true);
    const updated = rowsManager.filter((_, i) => i !== index);
    setRowsManager(updated);
    setTimeout(() => {
      handleSubmitByManager(updated); // Pass the updated rows directly
    }, 2000);
  };

  const handleAddRowManagerEditClick = () => {
    markUserEditing();
    handleAddRowManagerEdit();
  };

  useEffect(() => {
    if (tripRowsUserEditing) return;
    const assigneeEmp = (employees || []).find((e) => e.EmpEmail === selectedemail);
    // filteredPersonDescription already scopes by service line (taskMatchesOpsManagerResourceOtherExpenses).
    // Do not hide rows by description label (Airfare, Car Rental, Lodging) on Software/Cloud/Hardware — only
    // installation-tagged tasks are excluded on those rows; OP-entered Airfare on Software must remain visible.
    const manualOnly = (filteredPersonDescription || []).filter((t) => {
      if (isTrainingExpenseDisplayRow(t)) return false;
      return true;
    });
    const manualRows =
      manualOnly.length > 0
        ? manualOnly.map((task) => ({
            description: task.description || "",
            value: task.value ?? "",
            notes: task.notes || "",
          }))
        : [{ description: "", value: "", notes: "" }];

    let ordered = consolidateTrainingExpenseRowsForDisplay(manualRows);

    if (isProjectRequestedBucket && assigneeEmp?._id) {
      const live = getLiveTrainingRollupForOpsAssigneeProject({
        projectRow: row,
        managerOPProject,
        assigneeEmp,
        trainingsEnvelope: mytrainings,
        projects: projects?.projects || projects || [],
        currencySymbol: currency,
      });
      const liveAmt = Number(live?.amount ?? 0);
      if (Number.isFinite(liveAmt) && liveAmt > 0) {
        const trainingRow = {
          description:
            live.description || `Training Cost (${currency})`,
          value: liveAmt,
          notes: "",
          sourceType: "training",
          readOnly: true,
        };
        ordered = consolidateTrainingExpenseRowsForDisplay([
          ...manualRows,
          trainingRow,
        ]);
      }
    }

    setTripRows(ordered);
  }, [
    filteredPersonDescription,
    employees,
    selectedemail,
    row,
    managerOPProject,
    mytrainings,
    projects,
    currency,
    isProjectRequestedBucket,
    tripRowsUserEditing,
  ]);

  const totalHours = rowsManager.reduce((total, row) => {
    return total + (parseFloat(getHoursValue(row)) || 0);
  }, 0);

  const handleSubmitByManager = React.useCallback(
    async (rowsToSubmit) => {
      const filteredRows = rowsToSubmit?.filter((entry) => {
        return (
          (entry.task && entry.task.trim() !== "") ||
          (getHoursValue(entry) &&
            getHoursValue(entry).toString().trim() !== "") ||
          (entry.notes && entry.notes.trim() !== "")
        );
      });
      const invalidRows = filteredRows?.filter(row => {
        const hasDescription = row.task && row.task.trim() !== "";
        const hoursValue = getHoursValue(row);
        const hasValue = hoursValue !== undefined && hoursValue !== null && hoursValue.toString().trim() !== "";
        return !hasDescription || !hasValue;
      });

      if (invalidRows?.length > 0) {
        return;
      }
      const projectid = row?._id;
      const taskownerid = currentAssignperson;
      const cleanedData = filteredRows.map((entry) => ({
        task: entry.task || "",
        hoursassigned: Number(getHoursValue(entry)) || 0,
        notes: entry.notes || "",
      }));

      setisLoadingtask(true);
      try {
        // Update with tasktype "other" (manager's update for resource)
        await dispatch(
          replaceAllWorkEntries({
            projectid: projectid,
            newEntries: cleanedData,
            tasktype: "other",
            taskownerid,
          })
        );
        // REMOVED: Don't update "self" when submitting for a resource
        // This was causing manager's own response to be overwritten
      } catch (error) {
        console.error("Failed to create task:", error);
      } finally {
        setisLoadingtask(false);
        setEffortRowsUserEditing(false);
        dispatch(getAllAutoSaveWorkentries());
        setFilteredEntries(cleanedData || []);
      }
    },
    [setisLoadingtask, currentAssignperson, row, dispatch]
  );

  const handledirectSubmit = async () => {

    if (selectedServiceType?.includes("Installation")) {
      // Check if installation exists and is an array
      if (!installation || !Array.isArray(installation)) {
        return;
      }

      const filteredRows = installation?.filter((row) => {
        return (
          (row.description && row.description.trim() !== "") ||
          (row.value && row.value.toString().trim() !== "") ||
          (row.notes && row.notes.trim() !== "")
        );
      });

      if (!filteredRows || !Array.isArray(filteredRows) || !filteredRows.length) {
        return;
      }

      if (!tripduration) {
        return;
      }
    }

    console.log("handledirectSubmit installation", installation);

    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === selectedemail
    );
    const projectid = row._id;
    const taskownerid = filteredEmployee?._id;


    console.log("handledirectSubmit before", projectid, taskownerid);
    if (!taskownerid && !projectid) {
      return;
    }
    console.log("handledirectSubmit after", projectid, taskownerid);

    const hasEffortEntries = (rowsManager || []).some((entry) => {
      const hoursValue = getHoursValue(entry);
      return (
        (entry.task && entry.task.trim() !== "") ||
        (hoursValue !== undefined &&
          hoursValue !== null &&
          hoursValue.toString().trim() !== "") ||
        (entry.notes && entry.notes.trim() !== "")
      );
    });

    try {
      if (hasEffortEntries) {
        await dispatch(submitWorkEntries({ projectid, taskownerid }));
      } else {
        // Backend /submit-task 404s when autosave is empty and leaves old workentries.
        // Response Received reads workentries — delete them so cleared efforts stay cleared.
        const staleIds = (entries || [])
          .filter(
            (entry) =>
              String(entry.projectid) === String(projectid) &&
              String(entry.taskownerid) === String(taskownerid) &&
              entry.isProjecttracking !== true
          )
          .map((entry) => entry._id)
          .filter(Boolean);
        if (staleIds.length > 0) {
          await dispatch(deleteTask(staleIds));
        }
        await dispatch(fetchWorkEntries());
      }
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      handlerefresh();
    }
  };

  const handleDescriptionSubmit = React.useCallback(
    async (updatedRows) => {
      const assigneeEmp = (employees || []).find((e) => e.EmpEmail === selectedemail);
      const taskownerid = currentAssignperson || assigneeEmp?._id;
      if (!taskownerid || !row?._id) {
        return;
      }

      const rowsPayload = ([]).concat(
        updatedRows != null ? updatedRows : triprows
      );
      const filteredRows = rowsPayload.filter((row) => {
        if (isTrainingExpenseDisplayRow(row)) return false;
        return (
          (row.description && row.description.trim() !== "") ||
          (row.value && row.value.toString().trim() !== "") ||
          (row.notes && row.notes.trim() !== "")
        );
      });
      const resourceTrainingBundles = isProjectRequestedBucket
        ? collapseTrainingBundlesToSingleRowPerAssignee(
            getTrainingExpenseBundlesForManagerResource({
              trainingsEnvelope: mytrainings,
              employees,
              projects,
              selectedemail,
              opemail,
              row,
              managerOPProject,
            })
          )
        : [];

      // Always continue so empty lists persist as [] and clear stale Other Expenses on resubmit
      const invalidRows =
        filteredRows?.length > 0
          ? filteredRows.filter((row) => {
            const hasDescription = row.description && row.description.trim() !== "";
            const hasValue =
              row.value !== undefined && row.value !== null && row.value.toString().trim() !== "";
            return !hasDescription || !hasValue;
          })
          : [];

      if (invalidRows?.length > 0) {
        return;
      }

      let defaultTypeService =
        filteredRows?.length > 0 ? filteredRows[0]?.typeservice : "";
      defaultTypeService = Array.isArray(defaultTypeService)
        ? defaultTypeService.find(Boolean) || ""
        : defaultTypeService;
      defaultTypeService =
        String(defaultTypeService || "").trim() ||
        String(Array.isArray(row?.TypeService) ? row.TypeService?.[0] : row?.TypeService ?? "").trim() ||
        String(
          Array.isArray(managerOPProject?.TypeService)
            ? managerOPProject?.TypeService?.[0]
            : managerOPProject?.TypeService ?? ""
        ).trim();
      const projectid = row._id;

      setisLoadingtask(true);
      try {
        const formdata = filteredRows.map((r) => ({
          description: r.description,
          notes: r.notes ?? "",
          typeservice: r.typeservice || defaultTypeService,
          value: r.value,
          taskstatus: "submit",
        }));

        const mergedFlat = mergeTrainingExpenseRowsInto(formdata || [], resourceTrainingBundles).map((r) =>
          normalizeDescriptionTaskWireEntry({
            ...r,
            typeservice: r.typeservice ?? defaultTypeService,
          })
        );

        await dispatch(
          replaceAllDescriptionTasks({
            projectid: projectid,
            taskownerid,
            tasktype: "other",
            entries: mergedFlat,
          })
        );
        // REMOVED: Don't update "self" when submitting for a resource
        // This was causing manager's own response to be overwritten
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        setisLoadingtask(false);
        setInitialEdit(false);
        dispatch(fetchDescriptionTasks());
        // handlerefresh()
      }
    },
    [
      dispatch,
      currentAssignperson,
      employees,
      isProjectRequestedBucket,
      managerOPProject,
      mytrainings,
      opemail,
      projects,
      row,
      selectedemail,
      triprows,
    ]
  );

  const handleManagerRowChange = (index, event) => {
    const { name, value } = event;
    setEffortRowsUserEditing(true);

    setRowsManager((prevRows) => {
      // Create a new array with updated row
      const updatedRows = prevRows.map((row, i) => {
        if (i !== index) return row;

        const newRow = { ...row };

        if (name === "hours" || name === "hoursassigned") {
          const sanitizedValue = sanitizeDecimalInput(value);
          newRow.hours = sanitizedValue;
          newRow.hoursassigned = sanitizedValue;
        } else if (name === "notes") {
          const filteredValue = value
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .slice(0, 40);
          newRow[name] = filteredValue;
        } else if (name === "tasks" || name === "task") {
          const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
          newRow[name] = filteredValue;
        } else {
          newRow[name] = value;
        }

        return newRow;
      });

      // Auto-save with the updated rows
      if (managerDebounceTimer) {
        clearTimeout(managerDebounceTimer);
      }

      const timer = setTimeout(() => {
        handleSubmitByManager(updatedRows); // Pass the updated rows
      }, 2000);

      setManagerDebounceTimer(timer);

      return updatedRows;
    });
  };

  useEffect(() => {
    return () => {
      if (managerDebounceTimer) {
        clearTimeout(managerDebounceTimer);
      }
    };
  }, [managerDebounceTimer]);

  const lastEditableTripRowIndex = React.useMemo(() => {
    for (let i = triprows.length - 1; i >= 0; i -= 1) {
      if (!isTrainingExpenseDisplayRow(triprows[i])) return i;
    }
    return -1;
  }, [triprows]);

  const handleTripInputChange = (index, field, value) => {
    setTripRowsUserEditing(true);
    // Clear any existing timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTripRows((prevRows) => {
      if (isTrainingExpenseDisplayRow(prevRows[index])) return prevRows;
      const newRows = [...prevRows];
      // Apply different validation based on field type
      let validatedValue;
      if (field === "value") {
        validatedValue = validateAmountValue(value);
      } else {
        validatedValue = validateDescriptionOrNotes(value);
      }

      newRows[index] = {
        ...newRows[index],
        [field]: validatedValue,
      };

      // Set new timeout for auto-submit
      const newTimeout = setTimeout(() => {
        handleDescriptionSubmit(newRows);
      }, 2000);

      setTypingTimeout(newTimeout);
      return newRows;
    });

    markUserEditing();
  };

  // Improved validation functions
  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };

  const handleAddRow = () => {
    setTripRowsUserEditing(true);
    setTripRows((prev) => {
      const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
      if (manuals.length >= 15) {
        enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
        return prev;
      }
      return appendManualOtherExpenseRow(prev);
    });
  };

  const handleRemoveRow = () => {
    setTripRowsUserEditing(true);
    const idx = lastEditableTripRowIndex;
    if (idx < 0) return;
    const updatedRows = consolidateTrainingExpenseRowsForDisplay(
      triprows.filter((_, i) => i !== idx)
    );
    setTripRows(updatedRows);
    setTimeout(() => {
      handleDescriptionSubmit(updatedRows);
    }, 2000);
  };

  useEffect(() => {
    if (effortRowsUserEditing) return;
    const currentEmployee = employees.find((emp) => emp.EmpEmail === opemail);

    if (currentEmployee && managerOPProject) {
      // 3. Filter entries based on conditions
      const filteredEntries = autosaveentries.filter(
        (entry) =>
          entry.projectid === managerOPProject._id &&
          entry.taskownerid === currentEmployee._id
      );
      setFilteredEntries(filteredEntries);
      // setNumberOfDays(filteredEntries.length > 0 ? filteredEntries[0].noofdays : "0");
      if (filteredEntries?.length > 0) {
        setRowsManager(filteredEntries);
      } else {
        setRowsManager([{ task: "", hoursassigned: "", notes: "" }]);
      }
    } else {
      console.error(
        "No matching employee found or acceptedProject not available"
      );
    }
  }, [autosaveentries, managerOPProject, opemail, setRowsManager, employees, effortRowsUserEditing]);

  const handleInstallationChange = (index, field, value) => {
    setInstallationUserEditing(true);
    const nextValue =
      field === "value" ? validateAmountValue(value) : value;
    setInstallation((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: nextValue,
      };
      return updated;
    });

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      // Use functional update to get the latest installation state
      setInstallation((latestInstallation) => {
        handleinstallationtaskSubmit(tripduration, latestInstallation);
        return latestInstallation; // Return unchanged since we're just using the value
      });
    }, 2000);

    setTypingTimeout(newTimeout);
  };

  const handletripdurationChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, "");
    setInstallationUserEditing(true);
    setTripDuration(numericValue);

    // Clear previous timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set new timeout
    const newTimeout = setTimeout(() => {
      handleinstallationtaskSubmit(numericValue);
    }, 2000);

    setTypingTimeout(newTimeout);
  };

  const handleinstallationtaskSubmit = React.useCallback(
    async (numericValue, newRows, forSubmit = false) => {
      // Use passed newRows when manager submits so we have latest installation state (fixes Other Expenses not saving for OP)
      const dataToSave = (newRows !== undefined && newRows !== null) ? newRows : installation;
      const filteredRows = resolveInstallationOtherExpenseRowsForPersistence(
        dataToSave || [],
        row,
        { forSubmit }
      );

      const resourceTrainingBundles = isProjectRequestedBucket
        ? collapseTrainingBundlesToSingleRowPerAssignee(
            getTrainingExpenseBundlesForManagerResource({
              trainingsEnvelope: mytrainings,
              employees,
              projects,
              selectedemail,
              opemail,
              row,
              managerOPProject,
            })
          )
        : [];

      // Always continue so empty lists persist as [] and clear stale Other Expenses on resubmit

      const invalidRows =
        filteredRows?.length > 0
          ? filteredRows.filter((row) => !(row.description && row.description.trim() !== ""))
          : [];

      if (invalidRows?.length > 0) {
        return;
      }

      setisLoadingtask(true);
      try {
        const manualOnly =
          filteredRows?.filter((r) => !isTrainingExpenseDisplayRow(r)) || [];
        const formdata = manualOnly.map((row) => ({
          ...row,
          taskstatus: "submit",
          tripduration: numericValue ?? filteredRows[0]?.tripduration ?? "",
        }));

        const mergedFlat = mergeTrainingExpenseRowsInto(formdata || [], resourceTrainingBundles).map((entry) =>
          normalizeDescriptionTaskWireEntry({
            ...entry,
            tripduration: entry?.tripduration ?? numericValue ?? "",
          })
        );
        
        await dispatch(
          replaceAllDescriptionTasks({
            projectid: row._id,
            taskownerid: currentAssignperson,
            tasktype: "other",
            entries: mergedFlat,
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        if (forSubmit && rowIsInstallation) {
          const manualPersisted = (filteredRows || []).filter(
            (r) => !isTrainingExpenseDisplayRow(r)
          );
          const trainingPersisted = (filteredRows || []).filter((r) =>
            isTrainingExpenseDisplayRow(r)
          );
          const mergedPersisted = mergeInstallationOtherExpenseRowsWithDefaults(
            manualPersisted,
            currency
          );
          skipInstallationServerSyncRef.current = true;
          setInstallation(
            moveMiscellaneousInstallRowToEnd([
              ...mergedPersisted,
              ...trainingPersisted,
            ])
          );
        }
        setisLoadingtask(false);
        setInitialEdit(false);
        setInstallationUserEditing(false);
        dispatch(fetchDescriptionTasks()).finally(() => {
          skipInstallationServerSyncRef.current = false;
        });
      }
    },
    [
      dispatch,
      currentAssignperson,
      currency,
      employees,
      installation,
      moveMiscellaneousInstallRowToEnd,
      rowIsInstallation,
      isProjectRequestedBucket,
      managerOPProject,
      mytrainings,
      opemail,
      projects,
      row,
      selectedemail,
      setisLoadingtask,
    ]
  );

  const handleAddinstallationrow = () => {
    if (installation.length >= 15) return; // Maximum 15 rows
    setInstallationUserEditing(true);
    setInstallation([
      ...installation,
      { description: "", value: "", notes: "" },
    ]);
  };

  const handleRemoveinstallationrow = () => {
    // if (installation.length <= 1) return; // Minimum 1 row
    markUserEditing();
    setInstallationUserEditing(true);
    const newRows = [...installation];
    newRows.pop();
    setInstallation(newRows);
    setTimeout(() => {
      handleinstallationtaskSubmit(tripduration, newRows); // Pass the updated rows directly
    }, 2000);
  };
  const handleAddHardware = () => {
    if (hardware?.length < 15) {
      setHardware([
        ...hardware,
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
        },
      ]);
      resetTypingTimeout();
    }
  };

  const handleRemoveHardware = () => {
    const newHardware = [...hardware];
    newHardware.pop();
    setHardware(newHardware);
    setTimeout(() => {
      handlehardCostsAutoSubmitByManager(newHardware);
    }, 2000);
  };

  const handlehardwareInputChange = (index, key, value) => {
    let updated;
    setHardware((prev) => {
      updated = [...prev];

      // If changing description, find matching hardware data
      if (key === "assemblepartdescription") {
        const selectedPart = fetchedHardwareData?.find(
          (item) => item.assemblepartdescription === value
        );

        if (selectedPart) {
          updated[index] = {
            ...updated[index],
            assemblepartdescription: selectedPart.assemblepartdescription,
            partno: selectedPart.partnumber,
            unitprice: selectedPart.unitprice.toString(),
            quantity: "", // Reset quantity to empty
            totalprice: "", // Reset total price since quantity is empty
          };
        } else {
          updated[index] = {
            ...updated[index],
            [key]: value,
            partno: "",
            unitprice: "",
            quantity: "", // Reset quantity to empty
            totalprice: "", // Reset total price
          };
        }
      }
      // If changing quantity, recalculate total
      else if (key === "quantity") {
        const quantity = Number(value);
        const unitprice = Number(updated[index].unitprice || 0);

        updated[index] = {
          ...updated[index],
          quantity: value,
          totalprice:
            quantity && !isNaN(quantity)
              ? (unitprice * quantity).toFixed(2)
              : "0.00",
        };
      }
      // For other fields
      else {
        updated[index] = {
          ...updated[index],
          [key]: value,
        };
      }

      return updated;
    });

    // Reset and set timeout for auto-save
    if (typingTimeout) clearTimeout(typingTimeout);
    setTypingTimeout(
      setTimeout(() => {
        handlehardCostsAutoSubmitByManager(updated);
      }, 3000)
    );
  };
  const handleSelectOpen = () => {
    resetTypingTimeout();
  };

  const handlehardCostsAutoSubmitByManager = React.useCallback(
    async (newHardware) => {
      const filteredEmployee = employees.find(
        (emp) => emp?.EmpEmail === selectedemail
      );

      const updatedHardware = newHardware.map((item) => ({
        ...item,
        taskstatus: "auto-save",
      }));
      console.log(
        "handlehardCostsAutoSubmitByManager newHardware autosace",
        updatedHardware
      );
      const payload = {
        projectid: row._id,
        tasktype: "other",
        taskownerid: filteredEmployee?._id,
        tasks: updatedHardware,
      };
      setisLoadingtask(true);
      try {
        // Update with tasktype "other" (manager's update for resource)
        await dispatch(replaceAllHardwareDescriptions(payload));
        // REMOVED: Don't update "self" when submitting for a resource
        // This was causing manager's own response to be overwritten
      } catch (error) {
        console.error("Error transforming hardware data:", error);
      } finally {
        setisLoadingtask(false);
        dispatch(fetchHardware());
        dispatch(getAllAssemblyInventory());
      }
    },
    [row, dispatch, setisLoadingtask, employees, selectedemail]
  );

  const handlehardCostsSubmitByManager = React.useCallback(async () => {
    const hasEmptyFields = hardware.some((item) => {
      return (
        !item.assemblepartdescription ||
        !item.partno ||
        !item.quantity ||
        !item.totalprice ||
        !item.unitprice
      );
    });

    if (hasEmptyFields) {
      return;
    }
    
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === selectedemail
    );

    const updatedHardware = hardware.map((item) => ({
      ...item,
      taskstatus: "submit",
    }));

    console.log(
      "handlehardCostsAutoSubmitByManager newHardware submit",
      updatedHardware
    );

    const payload = {
      projectid: managerOPProject._id,
      tasktype: "other",
      taskownerid: filteredEmployee?._id,
      tasks: updatedHardware,
    };
    setisLoadingtask(true);
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
      // REMOVED: Don't update "self" when submitting for a resource
      // This was causing manager's own response to be overwritten
    } catch (error) {
      console.error("Error transforming hardware data:", error);
    } finally {
      setisLoadingtask(false);
      dispatch(fetchHardware());
      handlerefresh();
    }
  }, [
    hardware,
    handlerefresh,
    dispatch,
    setisLoadingtask,
    managerOPProject._id,
    employees,
    selectedemail,
  ]);

  const resetTypingTimeout = useCallback(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardCostsAutoSubmitByManager();
    }, 3000);
    setTypingTimeout(newTimeout);
  }, [typingTimeout, handlehardCostsAutoSubmitByManager]);

  const updatebyname = useCallback(async () => {

    if (selectedServiceType?.includes("Installation")) {
      // Check if installation exists and is an array
      if (!installation || !Array.isArray(installation)) {
        return;
      }

      const filteredRows = installation?.filter((row) => {
        return (
          (row.description && row.description.trim() !== "") ||
          (row.value && row.value.toString().trim() !== "") ||
          (row.notes && row.notes.trim() !== "")
        );
      });

      if (!filteredRows || !Array.isArray(filteredRows) || !filteredRows.length) {
        return;
      }

      if (!tripduration) {
        return;
      }
    }

    // Update task status for the selected person (self or operation person).
    // When manager submits for an operation person, call updateTaskStatus with that OP's userid so status changes to submit.
    const updatedAssignedperson = (row.Assignedperson || [])
      .filter((person) => person.email === selectedemail)
      .map((person) => ({
        ...person,
        taskStatus: "submit",
      }));
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );
    const selectedProjectId = row?._id;
    const SelectedUserId = filteredEmployee?._id;
    if (!SelectedUserId || !selectedProjectId) {
      dispatch(getAllAutoSaveWorkentries());
      handlerefresh();
      return;
    }
    setisLoadingtask(true);

    try {
      await dispatch(
        updateTaskStatus({
          projectid: selectedProjectId,
          userid: SelectedUserId,
        })
      );
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      handlerefresh();
      setisLoadingtask(false);
    }
  }, [dispatch, selectedemail, handlerefresh, employees, selectedServiceType, row, installation, tripduration]);

  const hasValidEffortEntry = React.useMemo(
    () =>
      (rowsManager || []).some(
        (entry) => {
          const hours = getHoursValue(entry);
          return (
            entry.task &&
            String(entry.task).trim() !== "" &&
            hours !== undefined &&
            hours !== null &&
            String(hours).trim() !== ""
          );
        }
      ),
    [rowsManager]
  );

  const hasValidOtherExpenseEntry = React.useMemo(
    () =>
      (triprows || []).some(
        (r) =>
          !isTrainingExpenseDisplayRow(r) &&
          r.description &&
          String(r.description).trim() !== "" &&
          r.value !== undefined &&
          r.value !== null &&
          String(r.value).trim() !== ""
      ),
    [triprows]
  );

  const hasValidInstallationExpenseEntry = React.useMemo(
    () =>
      (installation || []).some(
        (r) =>
          !isTrainingExpenseDisplayRow(r) &&
          r.description &&
          String(r.description).trim() !== "" &&
          r.value !== undefined &&
          r.value !== null &&
          String(r.value).trim() !== ""
      ),
    [installation]
  );

  const hasValidHardwareEntry = React.useMemo(
    () =>
      (hardware || []).some(
        (item) =>
          item.assemblepartdescription &&
          String(item.assemblepartdescription).trim() !== "" &&
          item.quantity &&
          Number(item.quantity) > 0
      ),
    [hardware]
  );

  // Keep Submit available after deleting all rows so stale Response Received workentries can be cleared
  const hasStaleWorkentriesToClear = (entries || []).some(
    (entry) =>
      String(entry.projectid) === String(row?._id) &&
      String(entry.taskownerid) === String(currentAssignperson) &&
      entry.isProjecttracking !== true
  );

  const canShowSubmit =
    (filteredEntries?.length > 0) ||
    hasValidEffortEntry ||
    hasValidOtherExpenseEntry ||
    hasValidInstallationExpenseEntry ||
    hasValidHardwareEntry ||
    hasStaleWorkentriesToClear;

  const handleAction = async () => {
    const filteredRows = installation?.filter((row) => {
      return (
        (row.description && row.description.trim() !== "") ||
        (row.value !== undefined && row.value !== null && row.value.toString().trim() !== "") ||
        (row.notes && row.notes.trim() !== "")
      );
    });
    if (selectedServiceType?.includes("Installation")) {
      if (!filteredRows || !Array.isArray(filteredRows)) {
        return;
      }

      if (!filteredRows?.length) {
        return;
      }
      if (!tripduration) {
        enqueueSnackbar("Please add tripduration.", {
          variant: "error",
        })
        return;
      }
    }

    SetisLoading(true);
    // Flush current Effort Expenses (including empty) so deleted rows overwrite server state
    await handleSubmitByManager(rowsManager);
    await handledirectSubmit();
    const rowIsInstallationSubmit =
      normalizeAssignmentTypeServiceKey(row?.TypeService) === "installation" ||
      (Array.isArray(selectedServiceType)
        ? selectedServiceType.some((s) => String(s || "").toLowerCase().includes("installation"))
        : String(selectedServiceType || "").toLowerCase().includes("installation"));
    if (rowIsInstallationSubmit) {
      await handleinstallationtaskSubmit(tripduration, installation, true);
    } else {
      await handleDescriptionSubmit(triprows);
    }
    await handlehardCostsSubmitByManager();
    await updatebyname();
    SetisLoading(false);
    enqueueSnackbar("Response Submitted Successfully.", {
      variant: "success",
    });
    setSelectedActions({});
  };
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
      <div
        className={`custom-scroll w-full bg-white  ${taskTableRowId === row?._id ? "min-h-[20vh]" : ""
          } max-h-[53vh] overflow-auto pb-2`}
      >
        {(Array.isArray(selectedServiceType)
          ? selectedServiceType.some((service) => service.includes("Hardware"))
          : selectedServiceType?.includes("Hardware")) &&
          hardwareAction === "hardwarecost" && (
            <div className="mainhardwarekdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center">
                {/* Table Header */}
                <div className="flex flex-col w-full">
                  <div className="w-full flex flex-col">
                    <div className="head flex text-center bg-blue-500 text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                        Sr. No
                      </div>
                      <div className="w-60 border py-1 break-words whitespace-normal">
                        Assembly/Part Description
                      </div>
                      <div className="w-[20%] border p-1">Part No</div>
                      <div className="w-[20%] border p-1">Quantity</div>
                      <div className="w-[20%] border p-1">
                        Unit Cost ({currency})
                      </div>
                      <div className="w-[20%] border p-1">
                        Total Cost ({currency})
                      </div>
                    </div>
                    <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                      <div className=" border w-[10%] p-1 break-all whitespace-normal"></div>
                      <div className=" border w-60 pt-1  break-all whitespace-normal">
                        Total
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal  p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1"></div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1">
                        {USAComma(
                          hardware?.reduce((sum, item) => {
                            return sum + Number(item.totalprice);
                          }, 0)
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  {hardware?.map((row, index) => (
                    <React.Fragment key={index}>
                      {Assignperson?.taskStatus === "submit" ? (
                        <div className="flex items-center text-center w-full text-xs">
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              {/* Description Select */}
                              <div className="w-60  border p-1 break-all whitespace-normal">
                                {row.assemblepartdescription || ""}
                              </div>

                              {/* Part Number */}
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {row.partno || ""}
                              </div>

                              {/* Quantity Input */}
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {row.quantity || ""}
                              </div>

                              {/* Unit Price */}
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.unitprice) || ""}
                              </div>

                              {/* Total Price */}
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.totalprice || "")}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center text-center w-full text-xs">
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              {/* Description Select */}
                              <div className="w-60  border p-1 break-all whitespace-normal">
                                <select
                                  name="assemblepartdescription"
                                  value={row.assemblepartdescription || ""}
                                  onChange={(e) =>
                                    handlehardwareInputChange(
                                      index,
                                      "assemblepartdescription",
                                      e.target.value
                                    )
                                  }
                                  onFocus={handleSelectOpen}
                                  className="outline-none bg-white text-black border-none text-center w-full h-full"
                                >
                                  <option hidden value="">
                                    Select
                                  </option>
                                  {fetchedHardwareData?.map((option) => {
                                    const isAlreadySelected = hardware.some(
                                      (row, i) =>
                                        row.assemblepartdescription ===
                                        option.assemblepartdescription &&
                                        i !== index
                                    );

                                    return (
                                      <option
                                        key={option._id}
                                        value={option.assemblepartdescription}
                                        disabled={isAlreadySelected}
                                      >
                                        {option.assemblepartdescription}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>

                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {row.partno || ""}
                              </div>

                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                <input
                                  type="number"
                                  placeholder="enter quantity"
                                  value={row.quantity || ""}
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    // ✅ Only numbers with up to 3 decimal places
                                    if (
                                      /^\d*\.?\d{0,3}$/.test(value) ||
                                      value === ""
                                    ) {
                                      handlehardwareInputChange(
                                        index,
                                        "quantity",
                                        value
                                      );
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      !(
                                        (e.key >= "0" && e.key <= "9") || // numbers
                                        e.key === "." || // decimal
                                        e.key === "Backspace" ||
                                        e.key === "Delete" ||
                                        e.key === "ArrowLeft" ||
                                        e.key === "ArrowRight" ||
                                        e.key === "Tab"
                                      )
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="w-full h-full border text-center border-gray-300 rounded-md p-0.5"
                                />
                              </div>

                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.unitprice) || ""}
                              </div>

                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.totalprice || "")}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}

                  {Assignperson?.taskStatus === "submit" ? (
                    <></>
                  ) : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddHardware}
                        disabled={hardware.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={handleRemoveHardware}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        {(Array.isArray(selectedServiceType)
          ? selectedServiceType.some((service) =>
            service.includes("Installation")
          )
          : selectedServiceType?.includes("Installation")) &&
          Action === "otherExpenses" && (
            <div className="bg-white rounded-lg justify-center h-full w-full min-h-[22vh] ">
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                <div className="flex flex-col w-full">
                  <div className="w-full">
                    <div className="head flex text-center bg-blue-500 text-white text-xs">
                      <div className="w-[50%] border p-2 font-semibold">
                        Trip Duration (Days)
                      </div>
                      <div className="w-[50%] border p-2">
                        {Assignperson?.taskStatus === "submit" ? (
                          <>{tripduration}</>
                        ) : (
                          <input
                            value={tripduration}
                            type="text"
                            onChange={(e) =>
                              handletripdurationChange(e.target.value)
                            }
                            placeholder="Enter duration"
                            className="h-full w-full outline-none bg-blue-500"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="w-full">
                    <div className="head flex text-center bg-blue-500 text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                        Sr. No
                      </div>
                      <div className="w-[40%] border p-2">Description</div>
                      <div className="w-[25%] border p-2">
                        Amount ({currency})
                      </div>
                      <div className="w-[25%] border p-2">Notes</div>
                    </div>
                    <div className="head flex text-center  text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                      <div className="w-[40%] border p-2">Total</div>
                      <div className="w-[25%] border p-2">
                        {formatAmountComma(installationOtherGrandTotal)}
                      </div>
                      <div className="w-[25%] border p-2"></div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {installationRowsForTable.map((expRow, index) => (
                    <React.Fragment
                      key={
                        expRow.sourceTrainingId
                          ? `ins-tr-${expRow.sourceTrainingId}-${expRow.projectid ?? row?._id ?? "p"}-${index}`
                          : `ins-row-${expRow.stateIndex}-${index}`
                      }
                    >
                      {Assignperson?.taskStatus === "submit" ? (
                        <div
                          className="flex items-center text-center w-full text-xs"
                          style={expRow.isTrainingExpense ? trainingExpenseRowStyle : undefined}
                        >
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              <div className="w-[40%] border p-2">
                                {expRow.description}
                              </div>

                              <div className="w-[25%] border p-2">
                                {formatAmountComma(expRow.value)}
                              </div>

                              <div className="w-[25%] border p-2">
                                {expRow.isTrainingExpense
                                  ? ""
                                  : formatExpenseNotesDisplayFromTasksRow(expRow, mytrainings) || ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="flex items-center text-center w-full text-xs"
                          style={expRow.isTrainingExpense ? trainingExpenseRowStyle : undefined}
                        >
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              <div className="w-[40%] border p-2">
                                <input
                                  type="text"
                                  name="description"
                                  placeholder="Enter description"
                                  disabled={expenseInputDisabled(expRow)}
                                  readOnly={expRow.isTrainingExpense}
                                  value={expRow.description}
                                  onChange={(e) => {
                                    if (typeof expRow.stateIndex !== "number") return;
                                    handleInstallationChange(
                                      expRow.stateIndex,
                                      "description",
                                      validateDescriptionOrNotes(e.target.value)
                                    );
                                  }}
                                  className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                                />
                              </div>

                              <div className="w-[25%] border p-2">
                                <input
                                  type="text"
                                  name="value"
                                  disabled={expenseInputDisabled(expRow)}
                                  readOnly={expRow.isTrainingExpense}
                                  value={formatAmountForInput(expRow.value)}
                                  placeholder="Enter Value"
                                  onFocus={(e) => {
                                    if (e.target.value === "0") e.target.select();
                                  }}
                                  onClick={(e) => {
                                    if (e.target.value === "0") e.target.select();
                                  }}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    if (typeof expRow.stateIndex !== "number") return;
                                    handleInstallationChange(
                                      expRow.stateIndex,
                                      "value",
                                      validateAmountValue(e.target.value)
                                    );
                                  }}
                                  className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                                />
                              </div>

                              <div className="w-[25%] border p-2">
                                <input
                                  type="text"
                                  name="notes"
                                  disabled={expenseInputDisabled(expRow)}
                                  readOnly={expRow.isTrainingExpense}
                                  value={expRow.isTrainingExpense ? "" : expRow.notes || ""}
                                  placeholder="Enter Notes"
                                  onChange={(e) => {
                                    const validValue = e.target.value.replace(
                                      /[^a-zA-Z0-9]/g,
                                      ""
                                    );
                                    if (typeof expRow.stateIndex === "number") {
                                      handleInstallationChange(
                                        expRow.stateIndex,
                                        "notes",
                                        validValue
                                      );
                                    }
                                  }}
                                  className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    </React.Fragment>
                  ))}

                  {Assignperson?.taskStatus === "submit" ? null : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddinstallationrow}
                        disabled={triprows.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleRemoveinstallationrow}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        {((Array.isArray(selectedServiceType)
          ? selectedServiceType.some((service) => service.includes("Hardware"))
          : selectedServiceType?.includes("Hardware")) &&
          hardwareAction === "otherexpenses") ||
          ((selectedServiceType?.includes("Software") ||
            selectedServiceType?.includes("Cloud")) &&
            Action === "otherExpenses") ? (
          <div className="maintaskdiv w-full bg-white">
            <div className="w-full bg-white rounded-lg h-full justify-center">
              <div className="flex flex-col w-full">
                <div className="w-full">
                  <div className="head flex text-center bg-blue-500 text-white text-xs">
                    <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                      Sr. No
                    </div>
                    <div className="w-[40%] border p-2">Description</div>
                    <div className="w-[25%] border p-2">
                      Amount ({currency})
                    </div>
                    <div className="w-[25%] border p-2">Notes</div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="head flex text-center  text-xs">
                    <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                    <div className="w-[40%] border p-2">Total</div>
                    <div className="w-[25%] border p-2">
                      {formatAmountComma(tripOtherGrandTotal)}
                    </div>
                    <div className="w-[25%] border p-2"></div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                {tripRowsForTable.map((expRow, index) => (
                  <React.Fragment
                    key={
                      expRow.sourceTrainingId
                        ? `hw-tr-${expRow.sourceTrainingId}-${expRow.projectid ?? row?._id ?? "p"}-${index}`
                        : `hw-row-${expRow.stateIndex}-${index}`
                    }
                  >
                    {Assignperson?.taskStatus === "submit" ? (
                      <div
                        className="flex items-center text-center w-full text-xs"
                        style={expRow.isTrainingExpense ? trainingExpenseRowStyle : undefined}
                      >
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">
                              {index + 1}
                            </div>

                            <div className="w-[40%] border p-2">
                              {expRow.description || ""}
                            </div>

                            <div className="w-[25%] border p-2">
                              {formatAmountComma(expRow.value || "")}
                            </div>

                            <div className="w-[25%] border p-2">
                              {expRow.isTrainingExpense
                                ? ""
                                : formatExpenseNotesDisplayFromTasksRow(expRow, mytrainings) || ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="flex items-center text-center w-full text-xs"
                        style={expRow.isTrainingExpense ? trainingExpenseRowStyle : undefined}
                      >
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">
                              {index + 1}
                            </div>

                            <div className="w-[40%] border p-2">
                              <input
                                type="text"
                                name="description"
                                disabled={expenseInputDisabled(expRow)}
                                readOnly={expRow.isTrainingExpense}
                                value={expRow.description || ""} // Ensure it handles undefined/null
                                onChange={(e) => {
                                  if (typeof expRow.stateIndex !== "number") return;
                                  handleTripInputChange(
                                    expRow.stateIndex,
                                    "description",
                                    e.target.value
                                  );
                                }}
                                placeholder="Enter Description"
                                className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                              />
                            </div>

                            <div className="w-[25%] border p-2">
                              <input
                                type="text"
                                name="value"
                                disabled={expenseInputDisabled(expRow)}
                                readOnly={expRow.isTrainingExpense}
                                value={formatAmountForInput(expRow.value || "")}
                                onChange={(e) => {
                                  if (typeof expRow.stateIndex !== "number") return;
                                  handleTripInputChange(
                                    expRow.stateIndex,
                                    "value",
                                    validateAmountValue(e.target.value)
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                              />
                            </div>

                            <div className="w-[25%] border p-2">
                              <input
                                type="text"
                                name="notes"
                                disabled={expenseInputDisabled(expRow)}
                                readOnly={expRow.isTrainingExpense}
                                value={expRow.isTrainingExpense ? "" : expRow.notes || ""}
                                onChange={(e) => {
                                  if (typeof expRow.stateIndex !== "number") return;
                                  handleTripInputChange(
                                    expRow.stateIndex,
                                    "notes",
                                    e.target.value
                                  );
                                }}
                                placeholder="Enter Notes"
                                className={`outline-none border-none text-center w-full h-full ${expenseInputCellCls(expRow)}`}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  </React.Fragment>
                ))}

                {Assignperson?.taskStatus === "submit" ? null : (
                  <div className="flex justify-between px-2 pt-1">
                    <button
                      type="button"
                      className="shadow-xl rounded-md p-1"
                      onClick={handleAddRow}
                      disabled={triprows.length >= 15}
                    >
                      <AddIcon />
                    </button>
                    <button
                      type="button"
                      className="shadow-xl rounded-md p-1"
                      onClick={handleRemoveRow}
                    >
                      <RemoveIcon />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}

        {Action === "task" && (
          <div className="w-full bg-white rounded-lg justify-center h-full min-h-[22vh]">
            <div className="flex w-full">
              <div className="w-full">
                <div className="head flex text-center bg-blue-500 text-white text-xs">
                  <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                    Sr. No
                  </div>
                  <div className="w-[40%] border p-2">Task</div>
                  <div className="w-[20%] border p-2">Hours</div>
                  <div className="w-[30%] border p-2">Notes</div>
                </div>
              </div>
            </div>

            {/* Total Row */}
            <div className="flex text-center w-full text-xs">
              <div className="w-full">
                <div className="head flex">
                  <div className="w-[10%] border p-1"></div>
                  <div className="w-[40%] border p-2">Total</div>
                  <div className="w-[20%] border p-2">{roundHours(totalHours)}</div>
                  <div className="w-[30%] border p-2"></div>
                </div>
              </div>
            </div>

            {/* Rows */}
            <div className="w-full">
              {rowsManager.map((row, index) =>
                Assignperson?.taskStatus === "submit" ? (
                  <div
                    className="flex items-center text-center w-full text-xs"
                    key={index}
                  >
                    <div className="w-full">
                      <div className="head flex">
                        <div className="w-[10%] border p-1">{index + 1}</div>

                        <div className="w-[40%] border p-2">{row.task}</div>

                        <div className="w-[20%] border p-2">
                          {getHoursValue(row)}
                        </div>

                        <div className="w-[30%] border p-2">{row.notes}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="flex items-center text-center w-full text-xs"
                    key={index}
                  >
                    <div className="w-full">
                      <div className="head flex">
                        <div className="w-[10%] border p-1">{index + 1}</div>

                        <div className="w-[40%] border p-2">
                          <input
                            type="text"
                            name="task"
                            value={row.task}
                            onChange={(e) =>
                              handleManagerRowChange(index, {
                                name: e.target.name,
                                value: e.target.value,
                              })
                            }
                            className="outline-none border-none text-center w-full h-full"
                          />
                        </div>

                        <div className="w-[20%] border p-2">
                          <input
                            type="text"
                            name="hoursassigned"
                            value={getHoursValue(row)}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              handleManagerRowChange(index, {
                                name: e.target.name,
                                value: e.target.value,
                              })
                            }
                            className="outline-none border-none text-center w-full h-full"
                          />
                        </div>

                        <div className="w-[30%] border p-2">
                          <input
                            type="text"
                            name="notes"
                            value={row.notes}
                            onChange={(e) =>
                              handleManagerRowChange(index, {
                                name: e.target.name,
                                value: e.target.value,
                              })
                            }
                            className="outline-none border-none text-center w-full h-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}

              {/* Add/Remove Buttons */}
              {Assignperson?.taskStatus === "submit" ? (
                <></>
              ) : (
                <div className="flex justify-between gap-2 mt-2 px-2">
                  <button
                    type="button"
                    className="shadow-xl rounded-md p-1"
                    onClick={() => {
                      setEffortRowsUserEditing(true);
                      handleAddRowManagerEditClick();
                    }}
                  >
                    <AddIcon />
                  </button>

                  <button
                    type="button"
                    className="shadow-xl rounded-md p-1"
                    onClick={() =>
                      handleRemoveRowManagerEdit(rowsManager.length - 1)
                    }
                  >
                    <RemoveIcon />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {Assignperson?.taskStatus === "submit" ? (
          <></>
        ) : (
          <div className="flex justify-end py-1 gap-1">
            {isLoadingtask && (
              <div className="mt-4 flex gap-1 align-middle items-center">
                <div className="text-sm">Saving Tasks </div>
                <SubmitLoader isLoadingtask={isLoadingtask} />
              </div>
            )}
            {canShowSubmit && (
              <button
                onClick={() => handleAction()}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
              >
                Submit
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ManagerTaskInputTable;
